import { BlockType } from '../../@types/BlockType';

export class ColorSettings {
  static AllColor = '#FFFFFF';

  static setAllColor(block: BlockType): void {
    block.setColour(this.AllColor);
  }

  static SceneColor = '#DD33DD';

  static setSceneColor(block: BlockType): void {
    block.setColour(this.SceneColor);
  }

  static ObjectColor = '#DD0000';

  static setObjectColor(block: BlockType): void {
    block.setColour(this.ObjectColor);
  }

  static AttributeColor = '#2099EE';

  static setAttributeColor(block: BlockType): void {
    block.setColour(this.AttributeColor);
  }

  static EnvironmentColor = '#0FBD8C';

  static setEnvironmentColor(block: BlockType): void {
    block.setColour(this.EnvironmentColor);
  }

  static PhysicsSystemColor = '#004499';

  static setPhysicsSystemColor(block: BlockType): void {
    block.setColour(this.PhysicsSystemColor);
  }

  static AnyColor = '#FF99CC';

  static setAnyColor(block: BlockType): void {
    block.setColour(this.AnyColor);
  }

  static ARColor = '#9966FF';

  static ARColorSecond = '#855CD6';

  static ARColorTertiary = '#774DCB';

  static setARColor(block: BlockType): void {
    block.setColour(this.ARColor);
  }

  static LogicColor = '#FFAB19';

  static LogicColorSecond = '#EC9C13';

  static LogicColorTertiary = '#CF8B17';

  static setLogicColor(block: BlockType): void {
    block.setColour(this.LogicColor);
  }

  static OperatorColor = '#59C059';

  static OperatorColorSecond = '#46B946';

  static OperatorColorTertiary = '#389438';

  static setOperatorColor(block: BlockType): void {
    block.setColour(this.OperatorColor);
  }

  static MoreColor = '#FF6680';

  static MoreColorSecond = '#FF4A6A';

  static MoreColorTertiary = '#FF3355';

  static setMoreColor(block: BlockType): void {
    block.setColour(this.MoreColor);
  }

  static OtherColor = '#222222';

  static OtherColorSecond = '#222222';

  static OtherColorTertiary = '#222222';

  static setOtherColorColor(block: BlockType): void {
    block.setColour(this.OtherColor);
  }
}
